import * as React from "react"
import cloud_img from "src/shared/assets/images/clouds.svg"
import { RadioCardProps } from "src/shared/config"

export const RadioCard: React.FC<RadioCardProps> = ({
  name,
  value,
  checked,
  defaultChecked,
  onChange,
  title,
  subtitle,
  image,
  imageAlt = "",
  after,
  id,
  disabled,
  className,
  style,
  children,
}) => {
  const reactId = React.useId()
  const inputId = id ?? `rc-${reactId}`

  const isControlled = checked !== undefined

  const [internalChecked, setInternalChecked] = React.useState<boolean>(!!defaultChecked)
  const [focused, setFocused] = React.useState(false)

  const isChecked = isControlled ? !!checked : internalChecked

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isControlled) setInternalChecked(e.target.checked)
    onChange?.(value, e)
  }
  const imgNode = typeof image === "string" ? <img className="radio-card__image" src={image} alt={imageAlt} /> : image

  return (
    <label
      className={["radio-card", isChecked ? "radio-card--checked" : "", disabled ? "radio-card--disabled" : "", focused ? "radio-card--focused" : "", className ?? ""]
        .filter(Boolean)
        .join(" ")}
      style={style}
      data-checked={isChecked ? "true" : "false"}
      data-disabled={disabled ? "true" : "false"}
      role="radio"
      aria-checked={isChecked}
      aria-disabled={disabled}
      htmlFor={inputId}
    >
      <input
        id={inputId}
        className="radio-card__input"
        type="radio"
        name={name}
        value={value}
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={handleChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />

      <div className="radio-card__body">
        {imgNode && <div className="radio-card__media">{imgNode}</div>}

        <div className="radio-card__content">
          {title && <div className="radio-card__title">{title}</div>}
          {subtitle && <div className="radio-card__subtitle">{subtitle}</div>}
          {children}
          <img className="background" src={cloud_img} alt="" />
        </div>

        <div className="radio-card__aside">{after}</div>
      </div>
    </label>
  )
}
